import { render, staticRenderFns } from "./SearchGeneral.vue?vue&type=template&id=49a63916"
import script from "./SearchGeneral.vue?vue&type=script&lang=js"
export * from "./SearchGeneral.vue?vue&type=script&lang=js"
import style0 from "./SearchGeneral.vue?vue&type=style&index=0&id=49a63916&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports